import {IResource} from '@simpli/resource-collection/dist/types/IResource'
import {Request} from '@simpli/serialized-request'
import {BlockchainVersion} from '@/model/resource/BlockchainVersion'
import {OrbitRound} from '@/model/resource/OrbitRound'
import {TokenPriced} from './TokenPriced'
import {OrbitProject} from './OrbitProject'

export class OrbitRoundReward implements IResource {
  idOrbitRoundRewardPk: number = 0

  blockchainVersion: BlockchainVersion | null = null
  orbitRound: OrbitRound | null = null
  tokenPriced: TokenPriced | null = null
  orbitProject: OrbitProject | null = null

  instance: number | null = null
  address: string | null = null
  amount: string | null = null
  status: string | null = null
  transactionHash: string | null = null
  createdAt: Date | null = null
  updatedAt: Date | null = null

  get $id() {
    return this.idOrbitRoundRewardPk
  }

  get $tag() {
    return String(this.idOrbitRoundRewardPk)
  }

  /**
   * Persists a new instance of OrbitRoundReward. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistOrbitRoundReward() {
    return await Request.post(`/client/orbit-round-reward`, this)
      .name('persistOrbitRoundReward')
      .asNumber()
      .getData()
  }
}
